// Crossfade the matching text item on the left when its image enters view on the right.
// Mirrors the sticky-two-column scroll scene used in section_why-providence_layout-2.
export default function initScrollingTwoColumn() {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia('(max-width: 767px)').matches) return;

    document.querySelectorAll('[data-scrolling-two-col]').forEach((section) => {
        const items = section.querySelectorAll('[data-scroll-item]');
        const images = section.querySelectorAll('[data-scroll-image]');
        if (!items.length || !images.length) return;

        const activate = (key) => {
            items.forEach((el) => {
                const match = el.getAttribute('data-scroll-item') === key;
                el.classList.toggle('is-active', match);
            });
        };

        // Track ratios and pick the image with the largest visible ratio as "active"
        const ratios = new Map();

        const io = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                ratios.set(entry.target.getAttribute('data-scroll-image'), entry.intersectionRatio);
            });
            let best = { key: null, ratio: 0 };
            ratios.forEach((ratio, key) => {
                if (ratio > best.ratio) best = { key, ratio };
            });
            if (best.key) activate(best.key);
        }, {
            threshold: [0, 0.25, 0.5, 0.75, 1],
            root: null,
            rootMargin: '-20% 0px -20% 0px',
        });

        images.forEach((img) => io.observe(img));
    });
}
